import m from "./../../../dist/es2015/locales/ar.js";
export const am5locales_ar = m;